// extracted by mini-css-extract-plugin
module.exports = {"ProfilePicSkeleton":"ProfilePicSkeleton_ProfilePicSkeleton__1tO_y","loading":"ProfilePicSkeleton_loading__-PrAw"};